import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import router from "../router/index";  //  这里不需要引入

// create an axios instance
const url = 'https://www.ourproteinfactory.com'//正式
// const url = 'http://192.168.1.71:9020'//测试

const service = axios.create({
  baseURL: url
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (localStorage.getItem('user_token')) {
			//token字段是要和后端协商好的
			config.headers.common["token"] = localStorage.getItem('user_token');
			// debugger
		}
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['Token'] = localStorage.getItem('user_token')
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)


// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    return res
  },
  error => {
    console.log('err' + error) // for debug
    if(error.response.status == 401) {
      window.localStorage.removeItem("user_token");
      // removeToken('net_token');
      // router.push('/login');  // 这里写法错误
    }
    return Promise.reject(error)
  }
)


export default service 




// WEBPACK FOOTER //
// ./src/assets/js/utils/request.js